import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { AuthProvider } from './contexts/AuthContext'
import { FeedbackProvider } from './contexts/FeedbackContext'
import { FontSizeProvider } from './contexts/FontSizeContext'
import App from './App.tsx'
import './index.css'
import './styles/dragndrop.css'
import './i18n'

// Mobile viewport height fix - accounts for browser UI (address bar, etc.)
const setViewportHeight = () => {
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}
setViewportHeight()
window.addEventListener('resize', setViewportHeight)
window.addEventListener('orientationchange', () => {
  // Delay to allow browser to recalculate
  setTimeout(setViewportHeight, 100)
})

// 動的インポートの取得失敗時に自動リロード
// デプロイでチャンクファイル名（ハッシュ）が変わると、開いたままの古いタブが
// 遅延読み込みルート（/files 等）で旧ファイルを取得できず TypeError になるため。
// リロードループ防止として60秒に1回まで。
window.addEventListener('vite:preloadError', (event) => {
  const KEY = 'preload-error-reload-at'
  const last = Number(sessionStorage.getItem(KEY) || 0)
  if (Date.now() - last < 60_000) return // 直近にリロード済み → Sentryに任せる
  sessionStorage.setItem(KEY, String(Date.now()))
  event.preventDefault() // エラーを握りつぶして代わりにリロード
  window.location.reload()
})

// Initialize Sentry
Sentry.init({
  dsn: 'https://3f0e61d7e4a70889879c04df33b1d7ee@o4510231267508224.ingest.us.sentry.io/4510231772004352',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // 100% of transactions (reduce in production)
  // Session Replay
  replaysSessionSampleRate: 0.1, // 10% of normal sessions
  replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors
  environment: import.meta.env.MODE,
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <FeedbackProvider>
        <FontSizeProvider>
          <App />
        </FontSizeProvider>
      </FeedbackProvider>
    </AuthProvider>
  </React.StrictMode>,
)